module.exports = __webpack_public_path__ + "img/smart-influencer.20d190cf.png";